import { render, staticRenderFns } from "./DownloadImageCard.vue?vue&type=template&id=24add4fa&scoped=true&"
import script from "./DownloadImageCard.vue?vue&type=script&lang=js&"
export * from "./DownloadImageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24add4fa",
  null
  
)

export default component.exports